module.exports = ".edit-title {\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.edit-container {\n    height:300px;\n    overflow-y: scroll;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/user-edit-dialog/user-edit-dialog.component.css
// module id = ./src/app/shared/user-edit-dialog/user-edit-dialog.component.css
// module chunks = main